export default "__VITE_ASSET__6f02b543__"